export default __webpack_public_path__ + "images/akkoro_isotoxal_octagram_with_copy_v2.png";